import { FormattedMessage } from "react-intl";

import { InputField } from "@ps-design-system/components/Input";
import { Text } from "@ps-design-system/components/Text";
import LightbulbIcon from "@ps-design-system/icons/Lightbulb/Lightbulb32";

import { useIntl } from "react-intl-compat";

const BrandNameField = () => {
  const intl = useIntl();

  return (
    <div className="tw-flex tw-flex-col tw-gap-16">
      <div className="tw-flex tw-flex-col tw-gap-8">
        <Text typeface="headline-4-b" element="h2" className="tw-m-0">
          <FormattedMessage
            id="hosting.space_details.brand_name_header"
            defaultMessage="Add your brand name"
          />
        </Text>
        <Text typeface="body-2" element="p" className="tw-m-0">
          <FormattedMessage
            id="hosting.space_details.brand_name_text"
            defaultMessage="If your space has a publicly displayed venue or business name you can now add it to your listing to increase your visibility."
          />
        </Text>
      </div>

      <Text
        element="p"
        className="tw-m-0"
        prefix={
          <LightbulbIcon className="tw-flex-shrink-0 tw-text-yellow-600" />
        }
      >
        <FormattedMessage
          id="hosting.space_details.venue_name_example"
          defaultMessage='Example: "Lightcraft Studios"'
        />
      </Text>

      <InputField
        fullWidth
        name="brandName"
        placeholder={intl.formatMessage({
          id: "hosting.space_details.venue_name_placeholder",
          defaultMessage: "Optional - brand name",
        })}
        testId="space-details-form-brand-name-input"
      />
    </div>
  );
};

export { BrandNameField };
